"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    test: {
        params: {
            lt: 'log',
            pg: 'detail',
            articleId: '~article_id',
            articleMsgId: '~article_message_id',
            sourceType: '~source_type',
            articleType: '~article_type',
            articleCategory: '~ch_id1',
            articleSecondCategory: '~ch_id2',
            isOriginal: '~is_original',
            timeliness: '~timeliness',
            essayEventId: '~essay_event_id',
            solicitId: '~solicit_id',
            wmPeopleId: '~people_id',
            wmPeopleName: '~people_name',
            inviteType: '~invite_type',
            inviteSource: '~invite_source',
            accountType: '~account_type',
            seedName: '~seed_name',
            oa_subscribe: '~oa_subscribe',
            seedSite: '~site',
            category: '~ch_id1',
            _extend: ['~rating', '~title', '~item_id', '~content_type', '~media_type', '~oa_id', '~oa_type'],
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdFJ1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGF0UnVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGtCQUFlO0lBQ1gsSUFBSSxFQUFFO1FBQ0YsTUFBTSxFQUFFO1lBQ0osRUFBRSxFQUFFLEtBQUs7WUFDVCxFQUFFLEVBQUUsUUFBUTtZQUNaLFNBQVMsRUFBRSxhQUFhO1lBQ3hCLFlBQVksRUFBRSxxQkFBcUI7WUFDbkMsVUFBVSxFQUFFLGNBQWM7WUFDMUIsV0FBVyxFQUFFLGVBQWU7WUFDNUIsZUFBZSxFQUFFLFNBQVM7WUFDMUIscUJBQXFCLEVBQUUsU0FBUztZQUNoQyxVQUFVLEVBQUUsY0FBYztZQUMxQixVQUFVLEVBQUUsYUFBYTtZQUN6QixZQUFZLEVBQUUsaUJBQWlCO1lBQy9CLFNBQVMsRUFBRSxhQUFhO1lBQ3hCLFVBQVUsRUFBRSxZQUFZO1lBQ3hCLFlBQVksRUFBRSxjQUFjO1lBQzVCLFVBQVUsRUFBRSxjQUFjO1lBQzFCLFlBQVksRUFBRSxnQkFBZ0I7WUFDOUIsV0FBVyxFQUFFLGVBQWU7WUFDNUIsUUFBUSxFQUFFLFlBQVk7WUFDdEIsWUFBWSxFQUFFLGVBQWU7WUFDN0IsUUFBUSxFQUFFLE9BQU87WUFDakIsUUFBUSxFQUFFLFNBQVM7WUFDbkIsT0FBTyxFQUFFLENBQUMsU0FBUyxFQUFFLFFBQVEsRUFBRSxVQUFVLEVBQUUsZUFBZSxFQUFFLGFBQWEsRUFBRSxRQUFRLEVBQUUsVUFBVSxDQUFDO1NBQ25HO0tBQ0o7Q0FFSixDQUFDIn0=